<template>
  <a-result
    status="500"
    title="401"
    :sub-title="subTitle || $t('layout.error-401')"
  >
    <template #extra>
      <a-button type="primary" @click="toHome">
        返回首页
      </a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  data () {
    const systemCodes = {
      'ERP': (
        <div>
          系统已停用，不支持进入系统
        </div>
      ),
      'BI': (
        <div>
          系统已停用，不支持进入系统
        </div>
      ),
      'AMAZON_OPERATE': (
        <div>
          系统已停用，不支持进入系统
        </div>
      ),
      'SYS_LISTING': (
        <div>
          系统已停用，不支持进入系统
        </div>
      )
    }
    return {
      subTitle: systemCodes[this.$route.params.systemCode]
    }
  },
  methods: {
    toHome () {
      this.$winOpen(`/#/user/home`, '_self')
    }
  }
}
</script>
